<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Financial Profiles'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'RequestForProposalResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'request-for-proposal',
        editEntityScreen: 'Admin - Edit/View Request For Proposals',
        fields: [
          { header: 'Name', prop: 'name', hideByDefault: false },
          { header: 'Code', prop: 'code', hideByDefault: false },
          { header: 'Party Ref', prop: 'partyReference', hideByDefault: false },
          { header: 'Due Date', prop: 'dueDate', hideByDefault: false },
          { header: 'Party', prop: item => (item.party && item.party.name) || '', hideByDefault: false }
        ]
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// RequestForProposalSearchResults.vue?c75730a8